import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseRepository } from '@common/data/base';
import { environment } from '@environment/environment';
import { ApiResources } from '@constants/api-resources';
import { PutNotificacaoDto } from './dto';

@Injectable()
export class NotificacaoRepository extends BaseRepository {
  constructor(http: HttpClient) {
    super(http, environment.serverAuthUrl, ApiResources.NOTIFICACAO);
  }

  putNotificacao(data: PutNotificacaoDto) {
    return this.customClient.put(`${this.basePath}`, data).pipe(
      (data: any) => (data ? data : this.handleResponseRequest(data))
    );
  }

  getQuantidadeNotificacoes(){
    return this.customClient.get(`${this.basePath}/novas`).pipe(
      (data: any) => (data ? data : this.handleResponseRequest(data))
    );
  }

}
